"use strict";
exports.__esModule = true;
exports.ProductionItemAccessoryBuilder = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var DesignerAssets_1 = require("../base/DesignerAssets");
var ProductionItemAccessoryBuilder = /** @class */ (function () {
    function ProductionItemAccessoryBuilder(item, accessory) {
        this.item = item;
        this.itemAssetsBuilder = DesignerAssets_1.DesignerAssetsBuilder.initialiseWithEmptyAssets().addAccessory(accessory);
    }
    ProductionItemAccessoryBuilder.initialise = function (quantity, accessory, accessoryReference, inventoryReference) {
        return new ProductionItemAccessoryBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            quantity: quantity,
            accessoryReference: accessoryReference,
            inventoryReference: inventoryReference
        }, accessory);
    };
    ProductionItemAccessoryBuilder.prototype.build = function () {
        return { item: this.item, assets: this.itemAssetsBuilder.build() };
    };
    return ProductionItemAccessoryBuilder;
}());
exports.ProductionItemAccessoryBuilder = ProductionItemAccessoryBuilder;
